<template>
  <v-app>
    <Loader :is-visible="loading"></Loader>

    <v-navigation-drawer
      v-model="drawer"
      v-if="!this.$route.path.includes('auth')"
      temporary
      fixed
    >
      <v-list dense>
        <v-list-item to="/auth/login" v-if="!isAuthenticated">
          <v-list-item-action>
            <v-icon>mdi-login-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Entrar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="isAuthenticated">
          <v-list-item to="/cidade">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Início</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/termo-referencia"
            v-if="
              ((groupsConfig.projetoseSolucoes && config.projetoseSolucoes) ||
                (isFullAdmin && !isNA)) &&
              !isIndicadores &&
              !isSala
            "
          >
            <v-list-item-action>
              <v-icon>mdi-book-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Projetos e Soluções</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/ur"
            v-if="
              isFullAdmin ||
              (groupsConfig.unidadesRegionais && config.unidadesRegionais)
            "
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Unidades Regionais</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/tema"
            v-if="isFullAdmin || (config.temas && groupsConfig.temas)"
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Temas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/eixos"
            v-if="isFullAdmin || (config.eixos && groupsConfig.eixos)"
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Eixos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/pacote"
            v-if="(groupsConfig.pacotes && config.pacotes) || isFullAdmin"
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Pacotes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            to="/pergunta"
            v-if="groupsConfig.perguntas && config.perguntas"
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Perguntas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            to="/medalha"
            v-if="isFullAdmin || (config.medalhas && groupsConfig.medalhas)"
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Medalhas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/usuario"
            v-if="isFullAdmin || (groupsConfig.usuarios && config.usuarios)"
          >
            <v-list-item-action>
              <v-icon>mdi-account-multiple</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Usuários</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/gestao-pagamento"
            v-if="
              isFullAdmin ||
              (groupsConfig.processosPagamento && config.processosPagamento)
            "
          >
            <v-list-item-action>
              <v-icon>mdi-file-search-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Processos de pagamentos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            :to="'/gestao-pagamento/usuario/' + user.usuarioId"
            v-if="
              isFullAdmin ||
              (groupsConfig.meusProcessosPagamentos &&
                config.meusProcessosPagamentos)
            "
          >
            <v-list-item-action>
              <v-icon>mdi-file-eye-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                >Meus Processos de Pagamentos</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/analisar-relatorios"
            v-if="
              isFullAdmin ||
              (config.analisarRelatorios &&
                groupsConfig.analisarRelatorios &&
                isAuthenticated &&
                !isIndicadores &&
                !isSala)
            "
          >
            <v-list-item-action>
              <v-icon>mdi-file-account</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                v-if="
                  isFullAdmin ||
                  isAdmin ||
                  isSPFesp ||
                  isSPFespEspecial ||
                  isSPCoordenador
                "
                >Analisar Relatórios</v-list-item-title
              >
              <v-list-item-title v-else>Meus Relatórios</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/analisar-relatorios-administrativos"
            v-if="config.analisarRelatoriosAdministrativos"
          >
            <v-list-item-action>
              <v-icon>mdi-file-account-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-if="isAdmin"
                >Analisar Relatórios Administrativos</v-list-item-title
              >
              <v-list-item-title v-if="!isAdmin"
                >Meus Relatórios Administrativos</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/eventos"
            v-if="isFullAdmin || (groupsConfig.eventos && config.eventos)"
          >
            <v-list-item-action>
              <v-icon>mdi-calendar-month-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Eventos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/encontros"
            v-if="
              isFullAdmin ||
              (isAuthenticated &&
                !isIndicadores &&
                !isSala &&
                groupsConfig.encontros &&
                config.encontros)
            "
          >
            <v-list-item-action>
              <v-icon>mdi-calendar-month-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Encontros</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/dashboard-administrativo"
            v-if="
              isFullAdmin ||
              (groupsConfig.dashboardAdministrativo &&
                config.dashboardAdministrativo)
            "
          >
            <v-list-item-action>
              <v-icon>mdi-poll</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Dashboard Administrativo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/tarefas/andamento"
            v-if="isFullAdmin || (isAdmin && uf === 'MS1')"
          >
            <v-list-item-action>
              <v-icon>mdi-poll</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Andamento das Tarefas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/rotas"
            v-if="isFullAdmin || (isAdmin && uf === 'MS1')"
          >
            <v-list-item-action>
              <v-icon>mdi-poll</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Rota do Consultor</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            to="/sala-principal"
            v-if="isFullAdmin || (isAdmin && uf === 'RJ' && !isSala)"
          >
            <v-list-item-action>
              <v-icon>mdi-poll</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sala do Empreendedor</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/usuario/atualizar-senha" v-if="isAuthenticated">
            <v-list-item-action>
              <v-icon>mdi-lock-question</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Atualizar Senha</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/configuracoes"
            v-if="
              isFullAdmin || (groupsConfig.configuracao && config.configuracao)
            "
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Configurações</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/groups"
            v-if="isFullAdmin || (groupsConfig.grupo && config.grupo)"
          >
            <v-list-item-action>
              <v-icon>mdi-store</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Grupos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="logout" v-if="isAuthenticated">
            <v-list-item-action>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <div
      v-bind:class="{
        'cidades-empreendedoras-header':
          !this.$route.path.includes('diagnostico'),
      }"
      v-if="
        !this.$route.path.includes('diagnostico') &&
        !this.$route.path.includes('auth')
      "
    >
      <img src="../public/assets/img/sebrae-logo.png" width="100px" />
    </div>

    <v-app-bar
      app
      class="menu"
      v-if="
        !this.$route.path.includes('diagnostico') &&
        !this.$route.path.includes('auth')
      "
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline">
        <span>
          <v-img
            v-if="isSala"
            :src="require(`../public/assets/img/${$store.state.logo}`)"
            width="180px"
          >
          </v-img>
          <v-img
            v-else
            :src="require(`../public/assets/img/${$store.state.logo}`)"
            width="200px"
          >
          </v-img>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-content
      v-bind:class="{ logged: !this.$route.path.includes('diagnostico') }"
    >
      <router-view />
    </v-content>

    <v-footer
      color="primary"
      class="app-footer"
      v-if="!this.$route.path.includes('diagnostico')"
    >
      <span v-if="this.$store.state.uf != 'SP' && !isSala && !isAT"
        >Cidade Empreendedora - SEBRAE / {{ this.$store.state.uf }}</span
      >
      <span v-if="this.$store.state.uf === 'SP' && !isSala && !isAT"
        >Consórcio Empreendedor - {{ this.$store.state.uf }}</span
      >
      <span v-if="isSala"
        >Selo de Referência Sala do Empreendedor -
        {{ this.$store.state.uf }}</span
      >
      <span v-if="isAT">Agentes Territoriais - {{ this.$store.state.uf }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Auth from "@/Auth.js";
import Cookies from "@/components/cookies/cookies";
import { atualUfDefinition } from "./helpers/utils";

export default {
  name: "App",
  components: {
    Loader,
    Cookies,
  },
  computed: {
    ...mapGetters([
      "isLogged",
      "isAuthenticated",
      "isConsultor",
      "isAdmin",
      "isAnalista",
      "loading",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "user",
      "urlTag",
      "uf",
      "logo",
      "isNA",
      "isFullAdmin",
      "isIndicadores",
      "isSala",
      "isAT",
      "config",
      "groupsConfig",
    ]),
  },
  created() {
    this.setConfig(localStorage.getItem("config"));
    this.setGroupsConfig(localStorage.getItem("groupsConfig"));

    this.mudaUf();
    var token = localStorage.getItem("token") || null;
    var expired = localStorage.getItem("expired") || false;
    var user = JSON.parse(localStorage.getItem("user")) || {};
    var city = localStorage.getItem("city") || null;
    var cityId = localStorage.getItem("cityId") || null;

    if (city !== null) this.setCityName(city);
    if (cityId !== null) this.setCityId(cityId);
    if (token !== null) this.setToken(token);
    if (token !== null) {
      if (user.email === "admin@admin.com.br") {
        user.grupo.verTodosEixos = true;
        user.grupo.visualizaMunicipio = true;
        this.setFullAdmin(true);
      }

      if (user.grupo.nome === "Administrador" || user.grupo.nome === "Cogestor")
        this.setAdmin(true);
      else if (user.grupo.nome === "Consultor") this.setConsultor(true);
      else if (user.grupo.nome === "Analista") this.setAnalista(true);
      else if (user.grupo.nome === "Analista Regional") this.setAnalista(true);
      else if (user.grupo.nome === "AD") this.setAD(true);
      else if (user.grupo.nome === "Backoffice FESPSP") this.setSPFesp(true);
      else if (user.grupo.nome === "Backoffice FESPSP Especial")
        this.setSPFespEspecial(true);
      else if (user.grupo.nome === "Coordenador de Produto")
        this.setSPCoordenador(true);

      this.setUser(user);
    }

    Auth.setItem("expired", expired);
  },
  data() {
    return {
      drawer: false,
      estado: this.$store.state.uf,
      logouf: this.$store.state.logo,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setIndicadores",
      "setUser",
      "setAdmin",
      "setConsultor",
      "setAnalista",
      "setAD",
      "setForcedLogout",
      "setCityName",
      "setCityId",
      "setIsSala",
      "setIsAT",
      "setUf",
      "setUrlTag",
      "setLogo",
      "setSPFesp",
      "setSPFespEspecial",
      "setSPCoordenador",
      "setNA",
      "setConfig",
      "setFullAdmin",
      "setGroupsConfig",
    ]),
    mudaUf() {
      this.setUrlTag(atualUfDefinition.urlTag);
      this.setUf(atualUfDefinition.uf);
      this.setNA(atualUfDefinition.na);
      this.setLogo(atualUfDefinition.logo);
      this.setIsSala(atualUfDefinition.isSala);
      this.setIsAT(atualUfDefinition.isAT);
      this.setIndicadores(atualUfDefinition.isIndicadores);
      setInterval(function () {
        document.documentElement.style.setProperty(
          "--corPrimaria",
          atualUfDefinition.corPrimaria
        );
      }, 100);

      if (atualUfDefinition.isSala) {
        document.title = "Selo Sala do Empreendedor";
      }
      if (atualUfDefinition.isAT) {
        document.title = "Agentes Territoriais";
      }
    },
    enableInterceptor() {
      this.$http.interceptors.request.use(
        (config) => {
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
      this.$http.interceptors.response.use(
        (response) => {
          return response;
        },
        (err) => {
          if (
            err.response.status === 401 &&
            err.response.data.message !==
              "Acesso inativo. Em caso de dúvidas consulte o gestor da área."
          ) {
            Auth.setItem("expired", true);
            this.$notification.error(
              "Sessão expirada, por favor entre novamente",
              { timer: 10, ignoreDuplicates: true }
            );
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/auth/login");
            });
          }
          return Promise.reject(err);
        }
      );
    },
    logout() {
      this.setForcedLogout(true);
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/auth/login");
      });
    },
  },
  mounted() {
    this.enableInterceptor();
    this.mudaUf();
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
